// InvoicePrintPreview.js 
import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import { useTranslation } from 'react-i18next'; 

// FIXED: Pure string formatting - NO Date object, NO timezone issues!
const formatDate = (isoString) => {
  if (!isoString) return '';
  // Split yyyy-mm-dd → [yyyy, mm, dd]
  const [year, month, day] = isoString.split('-');
  return `${day}/${month}/${year}`;  // → dd/mm/yyyy
};

const InvoicePrintPreview = ({ invoiceState, subTotal, taxAmount, discountAmount, total, balanceDue }) => {
  const { t } = useTranslation(); 
  const showDiscount = invoiceState.discountRate && parseFloat(invoiceState.discountRate) !== 0;

  return (
    <div id="invoicePrintPreview" style={{ position: 'absolute', left: '-9999px', width: '800px', fontFamily: "'Inter', sans-serif" }}>
      <div data-bs-theme="light" className="pdf-light-mode">
        <div className="p-4 p-xl-5">
          {/* Header: FIXED - Pure string formatting, NO timezone issues */}
          <div className="d-flex justify-content-between align-items-start mb-4">
            <div style={{ marginTop: '-10px' }}>
              {invoiceState.logo && <img src={invoiceState.logo} alt="Logo" style={{ maxWidth: '175px', maxHeight: '128px' }} />}
            </div>
            <div className="text-end">
              <h2 className="fw-bold mb-2">{t('invoiceTitle')} {invoiceState.invoiceNumber || ''}</h2>
              <p className="mb-1"><strong>{t('dateLabel')}</strong> {formatDate(invoiceState.invoiceDate)}</p>
              <p className="mb-1"><strong>{t('dueDateLabel')}</strong> {formatDate(invoiceState.dateOfIssue)}</p>
              <div style={{ backgroundColor: '#f8f9fa', borderRadius: '4px', padding: '8px', marginTop: '8px', fontSize: '1.25em', display: 'inline-block', width: '100%', textAlign: 'left' }}>
                <span className="fw-bold">{t('balanceDueLabel')} {invoiceState.currency} {balanceDue || '0.00'}</span>
              </div>
            </div>
          </div>
          <hr className="my-4" />
          <Row className="mb-5">
            <Col>
              <div style={{color:'#758A93'}}>{t('billedFromLabel')}</div>
              <div className="fw-bold">{invoiceState.billFrom || ''}</div>
              {invoiceState.billFromDocumentId && <div>{invoiceState.billFromDocumentId}</div>}
              <div>{invoiceState.billFromEmail || ''}</div>
              <div>{invoiceState.billFromAddress || ''}</div>
            </Col>
            <Col>
              <div style={{color:'#758A93'}}>{t('billedToLabel')}</div>
              <div className="fw-bold">{invoiceState.billTo || ''}</div>
              {invoiceState.billToDocumentId && <div>{invoiceState.billToDocumentId}</div>}
              <div>{invoiceState.billToEmail || ''}</div>
              <div>{invoiceState.billToAddress || ''}</div>
            </Col>
          </Row>
          {/* Items, totals, notes unchanged */}
          <Table hover className="mb-4" style={{ backgroundColor:'#212529', border: '0.5px solid #EEEEEE' }}>
            <thead style={{ backgroundColor:'#212529', border: '0.5px solid #212529' }}>
              <tr><th style={{ padding: '4px', paddingLeft: '10px' }}>{t('descriptionHeader')}</th><th className="text-center" style={{ padding: '4px' }}>{t('qtyHeader')}</th><th className="text-center" style={{ padding: '4px' }}>{t('priceHeader')}</th><th className="text-end" style={{ padding: '4px', paddingRight: '10px' }}>{t('amountHeader')}</th></tr>
            </thead>
            <tbody>
              {invoiceState.items.map((item, i) => (
                <tr key={i}><td className="fw-bold" style={{ padding: '8px' }}>{item.description}</td><td className="text-end" style={{ padding: '8px' }}>{item.quantity}</td><td className="text-end" style={{ padding: '8px' }}>{invoiceState.currency} {item.price}</td><td className="text-end" style={{ padding: '8px' }}>{invoiceState.currency} {item.price * item.quantity}</td></tr>
              ))}
            </tbody>
          </Table>
          <Row className="justify-content-end">
            <Col lg={6}>
              <div className="text-end">
                <div className="d-flex justify-content-between mb-1">
                  <span className="fw-bold">{t('subtotalLabel')}</span>
                  <span>{invoiceState.currency} {subTotal}</span>
                </div>
                {showDiscount && (
                  <div className="d-flex justify-content-between mb-1">
                    <span className="fw-bold">{t('discountAmount', { rate: invoiceState.discountRate })}</span>
                    <span>{invoiceState.currency} {discountAmount}</span>
                  </div>
                )}
                <div className="d-flex justify-content-between mb-1">
                  <span className="fw-bold">{t('taxAmount', { rate: invoiceState.taxRate || '0.00' })}</span>
                  <span>{invoiceState.currency} {taxAmount}</span>
                </div>
                <hr className="my-2" />
                <div className="d-flex justify-content-between fw-bold" style={{ fontSize: '1.2em' }}>
                  <span>{t('totalLabel')}</span>
                  <span>{invoiceState.currency} {total}</span>
                </div>
              </div>
            </Col>
          </Row>
          <br />
          <div style={{ marginTop: '20px' }}>
            {invoiceState.notes && (
              <div className="mb-3">
                <strong>{t('notesLabel')}</strong><br />
                {invoiceState.notes}
              </div>
            )}
            {invoiceState.termsAndConditions && (
              <div>
                <strong>{t('termsLabel')}</strong><br />
                {invoiceState.termsAndConditions}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoicePrintPreview;